export const isEmailServiceReady = (subuser) => {
	if (!subuser) return false;
	if (subuser.sendGridStatus === 'disabled') return false;
	return (
		subuser.sendGridStatus === 'active' ||
		subuser.sendGridStatus === 'pending_verification'
	);
};

export const buildEmailSetupSteps = ({
	isComplianceApproved,
	isComplianceSubmitted,
	hasEmailServiceReady,
	hasVerifiedDomain,
	hasSender,
}) => [
	{
		id: 'compliance',
		step: 1,
		shortLabel: 'Compliance',
		done: isComplianceSubmitted,
		waiting: false,
		waitingLabel: '',
		unlocked: true,
	},
	{
		id: 'awaiting-approval',
		step: 2,
		shortLabel: 'Awaiting approval',
		done: isComplianceApproved,
		waiting: isComplianceSubmitted && !isComplianceApproved,
		waitingLabel: 'Pending approval',
		unlocked: isComplianceSubmitted,
	},
	{
		id: 'domain',
		step: 3,
		shortLabel: 'Domain',
		done: hasVerifiedDomain,
		waiting: isComplianceApproved && !hasEmailServiceReady,
		waitingLabel: 'Setting up',
		unlocked: isComplianceApproved && hasEmailServiceReady,
	},
	{
		id: 'add-sender',
		step: 4,
		shortLabel: 'Add sender',
		done: hasSender,
		waiting: false,
		waitingLabel: '',
		unlocked: hasVerifiedDomain,
	},
];

export const getEmailSetupProgress = (steps) => {
	const completedCount = steps.filter((s) => s.done).length;
	const allDone = completedCount === steps.length;
	const activeStepId =
		steps.find((s) => !s.done && s.unlocked)?.id ||
		steps.find((s) => !s.done && s.waiting)?.id;
	const actionableStepId = steps.find(
		(s) => !s.done && s.unlocked && !s.waiting,
	)?.id;

	return {
		completedCount,
		allDone,
		activeStepId,
		actionableStepId,
		progressPercent: Math.round((completedCount / steps.length) * 100),
	};
};
